<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.yybj" alt>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Huperzine-A&nbsp;</span>
        </b>
      </p>
      <p>
        <u>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="text-decoration:none;">
              <br>
            </span>
          </span>
        </u>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Spec</span>
        <span style="font-size:12px;font-family:Arial;">:</span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Botanical Name: &nbsp; &nbsp; &nbsp; &nbsp; Lycopodium Serratum
          Thunb Var
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Part
            Used:
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">
            All
            Grass
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Assay:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
          <span style="font-size:12px;">&gt; 99.0% Huperzine-A</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Appearance
            (Visual):
          </span>
          <span style="font-size:12px;">&nbsp;</span>
          <span></span>
          <span style="font-size:12px;">Fine Powder</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Color:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;</span>
          <span style="font-size:12px;">Off White</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Oder</span>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;</span>
          <span style="font-size:12px;">Characteristic</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Taste:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Characteristic</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Mesh
            Size:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">
            NLT 100% through 80
            mesh
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Bulk
            Density:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">40-60g/100ml</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Loss
            on drying:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;</span>
          <span style="font-size:12px;">NMT1.0%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Heavy
            Metals:
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">NMT10ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Arsenic
            (As):
          </span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">NMT2ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Sterilization
            Method:
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;</span>
          <span style="font-size:12px;">
            High Temperature and
            Pressure
          </span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Total
            Plate Count:
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&lt;1,000cfu/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Yeast
            and Molds:
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&lt;100cfu/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Salmonella:</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Absent</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">E.Coli:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Absent</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Salmonella:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">Absent</span>
        </span>
      </p>
      <p>
        <u>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="text-decoration:none;">
              <br>
            </span>
          </span>
        </u>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Packing</span>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">:</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">
            in Al
            Foil
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        yybj: require("../../../assets/img/common/yybj.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/yybj.vue